module.exports = __webpack_public_path__ + "static/media/TORNUMHR8-27-3.8e461425.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/stores/presets/photos/TORNUMHR8-27-3.jpg
// module id = 159
// module chunks = 0